import React from 'react';
import CanvasserSeatRow from './CanvasserSeatRow';
import AddCanvasserDropZone from './AddCanvasserDropZone';
import TurfSection from './TurfSection';
import { useDoorCrewCard } from './DoorCrewCardContext';
import { TurfSeatGroup } from './groupSeatsByTurf';

interface TurfGroupCardProps {
  group: TurfSeatGroup;
  seatOffset: number;
  color?: string;
}

export default function TurfGroupCard({ group, seatOffset }: TurfGroupCardProps) {
  const { crew } = useDoorCrewCard();

  return (
    <div className="turf-group">
      <div className="turf-group-header">
        <TurfSection turf={group.turf} />
      </div>

      <div className="turf-group-seats-col">
        {group.seats.map((seat, index) => (
          <CanvasserSeatRow
            key={seat.id}
            seat={seat}
            seatNumber={seatOffset + index + 1}
          />
        ))}

        <AddCanvasserDropZone crewId={crew.id} turfId={group.turfId} />
      </div>
    </div>
  );
}
